import VerificationRouter from './router/verification-router';

export default VerificationRouter;
